import { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Dashboard from 'containers/Dashboard/index';
import AdministrationTools from 'containers/AdministrationTools';
import InspectionsToolkit from 'containers/InspectionsToolkit';
import SurveyDataManager from 'containers/SurveyDataManager';
import SdmRecipeVisibilityBridge from 'containers/SurveyDataManager/SdmRecipeVisibilityBridge';
import {
  getCanonicalAppPath,
  getDashboardHomePath,
  isAdministrationToolkitPath,
  isDashboardPath,
} from 'config/loginPortals';
import { SURVEY_DATA_VIEWER_PATH } from 'containers/SurveyDataManager/constants';
import './MainContent.scss';

/**
 * Mounts Dashboard and AdministrationTools only after each area is first opened,
 * so admin/tenants and admin/users are not fetched until needed.
 * Legend and Survey Image Viewer catalogues are prefetched once the dashboard
 * toolbar mounts so those panels open with data already warm.
 * Once opened, panels stay mounted to preserve map/admin state.
 */
function MainContent() {
  const location = useLocation();
  const canonicalPath = getCanonicalAppPath(location.pathname);
  const isAdminRoute = isAdministrationToolkitPath(location.pathname);
  const isSurveyDataViewerRoute = location.pathname.startsWith(
    SURVEY_DATA_VIEWER_PATH,
  );
  const isDashboardRoute =
    isDashboardPath(location.pathname) || isSurveyDataViewerRoute;
  const [hasOpenedAdminToolkit, setHasOpenedAdminToolkit] = useState(isAdminRoute);
  const [hasOpenedDashboard, setHasOpenedDashboard] = useState(isDashboardRoute);

  useEffect(() => {
    if (isAdminRoute) {
      setHasOpenedAdminToolkit(true);
    }
  }, [isAdminRoute]);

  useEffect(() => {
    if (isDashboardRoute) {
      setHasOpenedDashboard(true);
    }
  }, [isDashboardRoute]);

  if (canonicalPath) {
    return <Navigate to={canonicalPath} replace />;
  }

  if (!isAdminRoute && !isDashboardRoute) {
    return <Navigate to={getDashboardHomePath(location.pathname)} replace />;
  }

  return (
    <div className="main-content-wrapper">
      {hasOpenedDashboard ? (
        <div
          className={`main-content-panel ${isDashboardRoute ? 'main-content-panel--visible' : 'main-content-panel--hidden'}`}
          aria-hidden={!isDashboardRoute}
        >
          <Dashboard />
        </div>
      ) : null}
      {hasOpenedAdminToolkit ? (
        <div
          className={`main-content-panel ${isAdminRoute ? 'main-content-panel--visible' : 'main-content-panel--hidden'}`}
          aria-hidden={!isAdminRoute}
        >
          <AdministrationTools />
        </div>
      ) : null}
      <InspectionsToolkit />
      <SdmRecipeVisibilityBridge />
      <SurveyDataManager />
    </div>
  );
}

export default MainContent;
